import * as React from 'react';
const { useMemo, useCallback, useState, useEffect, forwardRef } = React;
import { debounce } from 'lodash';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';

import TextField, { TextFieldProps } from '../text-field';
import IconButton from '../icon-button';
import Icon from '../icon';


const useIconButtonStyles = makeStyles((theme) => ({
	iconButton: {
		padding: '6px',
		'&.MuiIconButton-edgeEnd': {
			marginRight: 0
		}
	}
}));

export type SearchFieldProps = {
	debounceTime?: number;
} & TextFieldProps

const SearchField = forwardRef<typeof TextField, SearchFieldProps>(({ value, debounceTime, onChange, ...rest }, ref) => {
	const [internalValue, setInternalValue] = useState<string>(value);
	const classes = useIconButtonStyles({});

	useEffect(() => {
		!value && setInternalValue('');
	}, [value]);

	const debouncedOnChange = useMemo(() => debounce(onChange, debounceTime), [onChange]);
	const handleChange = useCallback((e, value) => {
		setInternalValue(value);
		debouncedOnChange(e, value);
	}, [debouncedOnChange]);
	const handleClear = useCallback((e) => {
		setInternalValue('');
		debouncedOnChange(e, '');
	}, [onChange]);

	return (
		<TextField
			{...rest}
			ref={ref}
			value={internalValue}
			onChange={handleChange}
			InputProps={{
				startAdornment: 
					<InputAdornment position='start'>
						<Icon
							type='search'
							color='muted'
							width={20}
							height={20} />
					</InputAdornment>,
				endAdornment: 
					<IconButton
						edge='end'
						aria-label='Очистить поле'
						title='Очистить поле'
						className={classes.iconButton}
						onClick={handleClear}>
						<Icon
							type='clear'
							color='muted'
							width={16}
							height={16} />
					</IconButton>
				}}
		/>
	);
});

SearchField.displayName = 'SearchField';
SearchField.defaultProps = {
	debounceTime: 0,
};

export default SearchField;
